import styled from '@emotion/styled';
import { type FC, useEffect, useRef, memo } from 'react';

interface UserVideoProps {
  mediaStream: MediaStream | null;
  handleStalled: () => void;
}

export const UserVideo: FC<UserVideoProps> = memo(
  ({ mediaStream, handleStalled }) => {
    const videoElement = useRef<HTMLVideoElement>({
      srcObject: null,
    } as HTMLVideoElement);

    useEffect(() => {
      if (videoElement.current) {
        videoElement.current.srcObject = mediaStream;
      }
    }, [mediaStream]);

    return (
      <StyledVideo
        ref={videoElement}
        aria-label='Interpreter video'
        onWaiting={handleStalled}
        onStalled={handleStalled}
        onSuspend={handleStalled}
        autoPlay
      />
    );
  }
);

const StyledVideo = styled('video')`
  width: 100%;
  height: 100%;
  transform: rotateY(180deg);
  pointer-events: none;
`;
